import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Modal,
  Alert, // Added Alert for error display
  Spinner, // Added Spinner for loading display
} from "react-bootstrap";
import {
  FaTrash,
  FaArrowLeft,
  FaWhatsapp,
  FaPhoneAlt,
  // eslint-disable-next-line no-unused-vars
  FaFilePdf,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./orderpage.css";
import { CartContext } from "./CartContext";
import { v4 as uuidv4 } from "uuid";
// NOTE: Removed 'websiteDetails' import as we are fetching data dynamically
import config from "../config/config";
import defaultLogo from "../assets/zen_logo.png";
// eslint-disable-next-line no-unused-vars
import { PDFDownloadLink } from "@react-pdf/renderer";
// eslint-disable-next-line no-unused-vars
import Bill from "../pdf/Bill";
const OrderPage = () => {
  const { API_DOMAIN, subdomain } = config;
  const { cart, setCart, increaseQty, decreaseQty, removeItem, clearCart, storeTheme } =
    useContext(CartContext);

  // ----------- FORM STATE & VALIDATION -----------
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [phoneError, setPhoneError] = useState(""); // New state for phone validation

  // ----------- API & MODAL STATE -----------
  const [showPopup, setShowPopup] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [companyDetails, setCompanyDetails] = useState(null);
  const [liveProducts, setLiveProducts] = useState([]); // New state for dynamic company info
  // eslint-disable-next-line no-unused-vars
  const [pdfUrl, setPdfUrl] = useState('');
  const [waPdfLink, setWaPdfLink] = useState('');
  const [waOrderLink, setWaOrderLink] = useState('');
  const [placedOrderData, setPlacedOrderData] = useState(null);
  console.log("Company Details:", companyDetails);
  const [companyLoading, setCompanyLoading] = useState(true);

  const navigate = useNavigate();

  const companyLogo = (companyDetails?.img && companyDetails.img.trim() !== "" && companyDetails.img !== "null")
    ? companyDetails.img
    : defaultLogo;

  // ------------------ HANDLERS ------------------

  // Automated Abandoned Cart Lead Capture (Phase 3 Remarketing Engine)
  const recordAbandonedCart = async (targetPhone = phone, targetName = name) => {
    if (!targetPhone || targetPhone.length !== 10 || cart.length === 0) return;
    try {
      const cartSummary = cart.map((i) => `${i.product_name || i.name} (x${i.qty})`).join(", ");
      const cartTotal = total.toFixed(2);
      await fetch(`${API_DOMAIN}/leads.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "track_abandoned_cart",
          company_id: subdomain,
          customer_phone: targetPhone,
          customer_name: targetName || "Online Shopper",
          lead_source: "abandoned_cart",
          requirement_note: `🛒 Cart (${cart.length} items): ${cartSummary} | Total: ₹${cartTotal}`,
          quantity: totalQuantity,
          status: "new",
        }),
      });
    } catch (err) {
      console.log("Abandoned cart tracking notice:", err);
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    // Only allow digits and limit length to 10
    const filteredValue = value.replace(/\D/g, "").slice(0, 10);
    setPhone(filteredValue);

    // Clear error immediately if it meets 10 digits or is empty
    if (filteredValue.length === 10 || filteredValue.length === 0) {
      setPhoneError("");
    }

    // Automatically capture abandoned cart lead once customer inputs their valid 10-digit phone
    if (filteredValue.length === 10 && cart.length > 0) {
      recordAbandonedCart(filteredValue, name);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const closePopup = () => {
    setShowPopup(false);
    setName("");
    setPhone("");
    setAddress("");
    setPlacedOrderData(null);
    navigate("/");
  };

  // eslint-disable-next-line no-unused-vars
  const handlePrintReceiptFallback = () => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) return;
    const items = placedOrderData?.products || cart;
    const itemsHtml = items
      .map(
        (item, idx) => `
      <tr>
        <td style="padding: 8px; border: 1px solid #ddd; text-align: center;">${idx + 1}</td>
        <td style="padding: 8px; border: 1px solid #ddd;">${item.name || item.product_name}</td>
        <td style="padding: 8px; border: 1px solid #ddd; text-align: center;">${item.qty}</td>
        <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">₹${item.per_price || item.price}</td>
        <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">₹${item.total_price || (Number(item.price || 0) * Number(item.qty || 1)).toFixed(2)}</td>
      </tr>
    `
      )
      .join("");

    const orderTotalDisplay = placedOrderData?.total || total.toFixed(2);

    const html = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Order Receipt - ${orderId}</title>
        <style>
          body { font-family: 'Segoe UI', Arial, sans-serif; padding: 20px; color: #333; max-width: 700px; margin: 0 auto; }
          .header { text-align: center; border-bottom: 2px solid #00a79d; padding-bottom: 12px; margin-bottom: 15px; }
          .header h2 { margin: 0; color: #00a79d; }
          .details { display: flex; justify-content: space-between; margin-bottom: 20px; font-size: 14px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 14px; }
          th { background: #00a79d; color: white; padding: 8px; border: 1px solid #00a79d; }
          .total { text-align: right; font-size: 16px; font-weight: bold; margin-top: 10px; }
        </style>
      </head>
      <body>
        <div class="header">
          <h2>${companyName}</h2>
          <p>${companyDetails?.address || ''} | Phone: ${contactNumber}</p>
          <h3>Order Receipt: ${orderId}</h3>
        </div>
        <div class="details">
          <div><strong>Customer:</strong> ${name}<br>Phone: ${phone}<br>Address: ${address}</div>
          <div style="text-align: right;"><strong>Date:</strong> ${new Date().toLocaleDateString()}</div>
        </div>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Product</th>
              <th>Qty</th>
              <th>Rate</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            ${itemsHtml}
          </tbody>
        </table>
        <div class="total">Total: ₹${orderTotalDisplay}</div>
        <script>
          window.onload = function() { window.print(); }
        </script>
      </body>
      </html>
    `;
    printWindow.document.write(html);
    printWindow.document.close();
  };

  // ------------------ DATA FETCHING (Company Details + Products) ------------------

  useEffect(() => {
    const fetchCompanyAndProducts = async () => {
      const companyId = subdomain;

      // 1. Fetch Company Details
      setCompanyLoading(true);
      try {
        const companyResponse = await fetch(`${API_DOMAIN}/company.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "", company_id: companyId }),
        });

        const companyData = await companyResponse.json();
        let loadedCompany = null;
        if (companyData.head.code === 200 && companyData.body.companies) {
          loadedCompany = companyData.body.companies[0];
          setCompanyDetails(loadedCompany);
        } else {
          console.error(
            "Failed to load company details:",
            companyData.head?.msg
          );
        }

        // 2. Fetch Live Products to ensure tax rates and GST details are fresh
        const prodResponse = await fetch(`${API_DOMAIN}/product.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ company_id: companyId, fetch_all: "true" }),
        });
        const prodData = await prodResponse.json();
        if (prodData.head?.code === 200 && Array.isArray(prodData.body?.products)) {
          const prods = prodData.body.products;
          setLiveProducts(prods);

          // Auto-hydrate cart items if missing gst_percent or gst_type
          if (cart && cart.length > 0 && typeof setCart === 'function') {
            const defType = loadedCompany?.default_gst_type || 'inclusive';
            let hasChanges = false;
            const updatedCart = cart.map((item) => {
              const matched = prods.find(
                (p) => String(p.id) === String(item.id) ||
                       String(p.product_id) === String(item.product_id) ||
                       String(p.product_code) === String(item.product_code)
              );
              if (matched) {
                const freshRate = Number(matched.gst_percent || 0);
                const freshType = (matched.gst_type && String(matched.gst_type).trim() !== '')
                  ? String(matched.gst_type).trim().toLowerCase()
                  : defType;
                const freshHsn = matched.hsn_code || item.hsn_code || '';
                if (item.gst_percent === undefined || Number(item.gst_percent) !== freshRate || item.gst_type !== freshType) {
                  hasChanges = true;
                  return {
                    ...item,
                    gst_percent: freshRate,
                    gst_type: freshType,
                    hsn_code: freshHsn,
                  };
                }
              }
              return item;
            });
            if (hasChanges) {
              setCart(updatedCart);
              try {
                localStorage.setItem("cart", JSON.stringify(updatedCart));
              } catch (e) {}
            }
          }
        }
      } catch (e) {
        console.error("Error fetching company or products:", e);
      } finally {
        setCompanyLoading(false);
      }
    };

    fetchCompanyAndProducts();
  }, [API_DOMAIN, subdomain]);

  // ------------------ ORDER CALCULATION ------------------
  // Strictly check company's gst_enabled flag (do not force enabled just because gst_no is present)
  const isGstEnabled = companyDetails?.gst_enabled === 1 || companyDetails?.gst_enabled === "1" || companyDetails?.gst_enabled === true;
  const isPerProductDiscount = companyDetails?.discount_mode !== "overall";

  // Indian Intra-State vs Inter-State Detection:
  const getIsInterState = () => {
    if (!address) return false;
    const cleanAddr = address.toLowerCase();

    // Default store state is Tamil Nadu (or from companyDetails.state or GSTIN starting with 33)
    let storeState = (companyDetails?.state || "").toLowerCase().trim();
    const gstNo = (companyDetails?.gst_no || "").trim();
    if (!storeState && gstNo.length >= 2 && gstNo.startsWith("33")) {
      storeState = "tamil nadu";
    }
    if (!storeState) storeState = "tamil nadu";

    // Known other Indian states:
    const otherStates = [
      "kerala", "karnataka", "andhra", "telangana", "maharashtra",
      "delhi", "gujarat", "rajasthan", "uttar pradesh", "madhya pradesh",
      "bihar", "west bengal", "punjab", "haryana", "odisha", "assam",
      "goa", "jharkhand", "chhattisgarh", "uttarakhand", "himachal",
      "chandigarh", "puducherry", "pondicherry"
    ];

    for (const os of otherStates) {
      if (os !== storeState && cleanAddr.includes(os)) {
        return true;
      }
    }
    // Default is always Intra-State (CGST + SGST) for local town/district addresses like "vnr", Chennai, Madurai, etc.
    return false;
  };
  const isInterState = getIsInterState();

  const grossSubTotal = cart.reduce((sum, item) => sum + (item.original_price || item.price) * item.qty, 0);
  const totalDiscountAmount = cart.reduce(
    (sum, item) => sum + Math.max(0, (item.original_price || item.price) - item.price) * item.qty,
    0
  );
  const subTotal = cart.reduce((sum, item) => sum + item.price * item.qty, 0);

  // Tax calculations
  let totalTaxable = 0;
  let totalTax = 0;
  let exclusiveTax = 0;

  const gstPrintMode = companyDetails?.gst_print_mode || "overall";
  const defGstPercent = Number(companyDetails?.default_gst_percent || 0);
  const defGstType = companyDetails?.default_gst_type || "inclusive";

  // Helper to reliably retrieve tax info from item or live products catalog
  const getProductTaxInfo = (item) => {
    const matched = liveProducts.find(
      (p) => String(p.id) === String(item.id) ||
             String(p.product_id) === String(item.product_id) ||
             String(p.product_code) === String(item.product_code)
    );
    let rate = (item.gst_percent !== undefined && item.gst_percent !== null && item.gst_percent !== "")
      ? Number(item.gst_percent)
      : (matched ? Number(matched.gst_percent || 0) : 0);
    let type = item.gst_type || matched?.gst_type || defGstType;
    if (type) type = String(type).trim().toLowerCase();
    if (!type) type = defGstType;
    const hsn = item.hsn_code || matched?.hsn_code || "";
    return { rate: Number(rate || 0), type, hsn };
  };

  if (isGstEnabled) {
    if (gstPrintMode === "per_product") {
      cart.forEach((item) => {
        const { rate, type } = getProductTaxInfo(item);
        const lineTotal = Number(item.price) * Number(item.qty);

        if (rate > 0) {
          if (type === "exclusive") {
            const tax = lineTotal * (rate / 100);
            totalTaxable += lineTotal;
            totalTax += tax;
            exclusiveTax += tax;
          } else {
            const taxable = lineTotal / (1 + rate / 100);
            const tax = lineTotal - taxable;
            totalTaxable += taxable;
            totalTax += tax;
          }
        } else {
          totalTaxable += lineTotal;
        }
      });
    } else {
      // Overall GST Mode: apply flat default rate & type on net subtotal
      const rate = defGstPercent;
      const type = defGstType;
      const lineTotal = subTotal;

      if (rate > 0) {
        if (type === "exclusive") {
          const tax = lineTotal * (rate / 100);
          totalTaxable = lineTotal;
          totalTax = tax;
          exclusiveTax += tax;
        } else {
          const taxable = lineTotal / (1 + rate / 100);
          const tax = lineTotal - taxable;
          totalTaxable += taxable;
          totalTax += tax;
        }
      } else {
        totalTaxable = lineTotal;
      }
    }
  } else {
    totalTaxable = subTotal;
  }

  const cgst = isInterState ? 0 : totalTax / 2;
  const sgst = isInterState ? 0 : totalTax / 2;
  const igst = isInterState ? totalTax : 0;
  const otherCharges = 0;
  const total = subTotal + exclusiveTax + otherCharges;
  const totalQuantity = cart.reduce((sum, item) => sum + item.qty, 0);

  // ------------------ PLACE ORDER LOGIC ------------------
  const handlePlaceOrder = async (e) => {
    e.preventDefault();

    // 1. Local Validation Check (Name, Address, Cart Empty)
    if (cart.length === 0 || !name || !address) {
      alert(
        "Please fill in all customer details and ensure your cart is not empty."
      );
      return;
    }

    // 2. Phone Validation Check (10 digits)
    if (phone.length !== 10) {
      setPhoneError("Mobile number must be exactly 10 digits.");
      return;
    }
    setPhoneError(""); // Clear error if validation passes

    setIsSubmitting(true);
    setError(null);

    const dynamicCompanyId = subdomain;
    console.log("Using Company ID for Order:", dynamicCompanyId);
    const orderPayload = {
      company_id: dynamicCompanyId,
      order_no: `ORD-${uuidv4().slice(0, 6).toUpperCase()}`,
      customer_details: JSON.stringify({
        name: name,
        phone: phone,
        address: address,
      }),
      product_details: JSON.stringify(
        cart.map((item) => {
          const { rate, type, hsn } = getProductTaxInfo(item);
          return {
            product_code: item.product_code,
            product_name: item.product_name,
            product_name_ta: item.product_name_ta || item.name_ta || "",
            product_id: item.product_id,
            original_price: (item.original_price || item.price).toFixed(2),
            price: item.price.toFixed(2),
            discount: (Math.max(0, (item.original_price || item.price) - item.price) * item.qty).toFixed(2),
            qty: item.qty,
            hsn_code: hsn,
            gst_percent: gstPrintMode === "per_product" ? rate : 0,
            gst_type: type,
            line_total: (item.price * item.qty).toFixed(2),
          };
        })
      ),
      sub_total: grossSubTotal.toFixed(2),
      discount: totalDiscountAmount.toFixed(2),
      other_charges: otherCharges.toFixed(2),
      grand_total: total.toFixed(2),
      user_id: 1,
      created_name: "Customer Order",
    };

    try {
      const response = await fetch(`${API_DOMAIN}/order.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderPayload),
      });

      console.log("Order API orderPayload:", orderPayload);

      const data = await response.json();

      if (data.head.code === 200) {
        const apiOrderId = data.body.order_no || orderPayload.order_no;
        setOrderId(apiOrderId);

        // Pre-build WhatsApp text for customer to send to store
        const cartSummary = cart
          .map(
            (item, idx) =>
              `${idx + 1}. ${item.product_name} x ${item.qty} = ₹${(
                item.price * item.qty
              ).toFixed(2)}`
          )
          .join("\n");
        const totalAmount = cart
          .reduce((sum, item) => sum + item.price * item.qty, 0)
          .toFixed(2);

        const customMessage = `Hello ${companyName},\nI have placed an order *${apiOrderId}* on your online store.\n\n*Customer Details:*\nName: ${name}\nPhone: ${phone}\nAddress: ${address}\n\n*Order Items:*\n${cartSummary}\n\n*Total Amount:* ₹${totalAmount}\n\nPlease confirm my order. Thank you!`;

        const fallbackLink = cleanedContactNumber
          ? `https://wa.me/91${cleanedContactNumber}?text=${encodeURIComponent(
              customMessage
            )}`
          : `https://wa.me/?text=${encodeURIComponent(customMessage)}`;

        setWaOrderLink(fallbackLink);

        // Prepare structured bill data for client-side PDF download (works for ALL stores)
        const billSnapshot = {
          enq: apiOrderId,
          date: new Date().toLocaleDateString(),
          customer: {
            name: name,
            address: address,
            city: companyDetails?.city || "",
            state: companyDetails?.state || "",
            email: "",
            mobile: phone,
          },
          sub_total: total.toFixed(2),
          package_charge: 0,
          total: total.toFixed(2),
          products: cart.map((item, idx) => ({
            id: item.product_id || item.id || idx,
            name: item.product_name,
            product_content: item.unit_name || item.unit || "Pcs",
            qty: item.qty,
            per_price: item.price,
            total_price: (Number(item.price) * Number(item.qty)).toFixed(2),
            discount_lock: 1,
            discount: 0,
          })),
        };
        // Also numeric keys for backward compatibility
        cart.forEach((item, idx) => {
          billSnapshot[idx] = {
            id: item.product_id || item.id || idx,
            name: item.product_name,
            product_content: item.unit_name || item.unit || "Pcs",
            qty: item.qty,
            per_price: item.price,
            total_price: (Number(item.price) * Number(item.qty)).toFixed(2),
            discount_lock: 1,
            discount: 0,
          };
        });
        setPlacedOrderData(billSnapshot);

        // Trigger Method 3 WhatsApp PDF microservice ONLY for digital price list stores
        const isDigitalStore = companyDetails?.store_type === 'digital_price_list';
        if (isDigitalStore) {
          try {
            const waRes = await fetch('https://whatsapp.zentexus.in/api/send-inquiry', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              store_id: subdomain || companyDetails?.company_code || 'default',
              subdomain: subdomain || '',
              company_id: companyDetails?.id || '',
              customer_phone: phone,
              admin_phone: companyDetails?.mobile || '',
              customer_name: name,
              customer_address: address,
              address: address,
              store_name: companyDetails?.company_name || 'Zen Store',
              company_name: companyDetails?.company_name || 'Zen Store',
              company_phone: companyDetails?.mobile || companyDetails?.phone || '',
              company_address: [companyDetails?.address, companyDetails?.city, companyDetails?.pincode].filter(Boolean).join(', ') || companyDetails?.address || '',
              items: cart.map(i => ({
                name: i.product_name,
                english_name: i.product_name,
                product_name: i.product_name,
                tamil_name: i.product_name_ta || i.name_ta || '',
                product_name_ta: i.product_name_ta || i.name_ta || '',
                name_ta: i.product_name_ta || i.name_ta || '',
                qty: i.qty,
                price: i.price
              })),
              remarks: `Order ID: ${apiOrderId}`
            })
          });
          const waData = await waRes.json();
          if (waData.code === 200 && waData.body) {
            setWaPdfLink(waData.body.customer_wa_link);
            setPdfUrl(waData.body.pdf_url);
          }
        } catch (waErr) {
          console.log('WhatsApp microservice offline:', waErr);
        }

        }

        // Phase 3: Mark abandoned cart lead as converted upon successful order
        try {
          fetch(`${API_DOMAIN}/leads.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'mark_cart_converted',
              company_id: dynamicCompanyId,
              customer_phone: phone,
              order_no: apiOrderId,
            })
          }).catch(e => console.log('Lead mark converted notice:', e));
        } catch (convErr) {
          console.log('Conversion tracking notice:', convErr);
        }

        clearCart();
        setShowPopup(true);
      } else {
        throw new Error(
          data.head.msg || "Order creation failed on the server."
        );
      }
    } catch (e) {
      console.error("Order API Error:", e);
      setError(`Failed to place order: ${e.message}`);
      alert(`Failed to place order: ${e.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const mobileFromCompany = String(companyDetails?.mobile || companyDetails?.phone || "");
  const companyName = companyDetails?.company_name || "Online Store";
  const contactNumber = mobileFromCompany || "N/A";
  const cleanedContactNumber = mobileFromCompany.replace(/[^\d]/g, "");
  const formattedContactNumber = cleanedContactNumber.length === 10 ? `91${cleanedContactNumber}` : cleanedContactNumber;
  const whatsappLink = `https://wa.me/${formattedContactNumber}`;

  if (companyLoading && !companyDetails) {
    return (
      <div className={`order-page-wrapper ${storeTheme}`}>
        <Container className="text-center py-5">
          <Spinner animation="border" variant={storeTheme === "theme3" ? "warning" : "primary"} />
          <p className="mt-2 text-muted">Loading order details...</p>
        </Container>
      </div>
    );
  }

  return (
    <div className={`order-page-wrapper ${storeTheme}`}>
      <Container fluid className="py-4">
        <Row className="justify-content-center">
          <Col md={10}>
            <Row className="mb-3">
              <Col>
                <Button
                  variant="primary"
                  onClick={handleGoBack}
                  className="btn-back text-white"
                  style={{ fontSize: "1rem" }}
                >
                  <FaArrowLeft />
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <Card className="mb-3 p-3 custom-card">
                  <Row>
                    <Col md={8}>
                      <h5>
                        <b>Order Summary</b>
                      </h5>
                    </Col>
                    <Col md={4} className="text-end">
                      <p className="item-count">
                        {totalQuantity > 0
                          ? `${totalQuantity} items`
                          : "0 items"}
                      </p>
                    </Col>
                  </Row>
                  <hr className="summary-divider" />
                  {cart.length === 0 ? (
                    <p>Your cart is empty.</p>
                  ) : (
                    cart.map((item) => (
                      <Row
                        key={item.id}
                        className="align-items-center mb-3 product-item order-product-row"
                      >
                        <Col xs={3} sm={2} className="order-product-media">
                          <img
                            src={item.product_img_url || companyLogo}
                            alt={item.product_name}
                            className="order-product-img"
                            onError={(e) => {
                              if (e.currentTarget.src !== companyLogo) {
                                e.currentTarget.src = companyLogo;
                              } else {
                                e.currentTarget.src = defaultLogo;
                              }
                            }}
                          />
                        </Col>
                        <Col xs={5} sm={6} className="order-product-info">
                          <h6>{item.product_name}</h6>
                          <div className="d-flex flex-column">
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                              <strong style={{ fontSize: '15px' }}>₹ {item.price.toFixed(2)}</strong>
                              {isGstEnabled && (() => {
                                const { rate, type } = getProductTaxInfo(item);
                                if (rate > 0) {
                                  return (
                                    <span className="badge bg-light text-secondary border" style={{ fontSize: '11px' }}>
                                      {type === 'exclusive' ? `+ ${rate}% GST` : `Incl. ${rate}% GST`}
                                    </span>
                                  );
                                }
                                return null;
                              })()}
                            </div>
                            {isPerProductDiscount && item.discount > 0 && (
                              <div className="d-flex align-items-center gap-2 mt-1">
                                <span className="text-decoration-line-through text-muted small" style={{ fontSize: '12px' }}>
                                  ₹ {(item.original_price || item.price).toFixed(2)}
                                </span>
                                <span className="text-danger fw-bold" style={{ fontSize: '12px' }}>
                                  {item.discount}% OFF
                                </span>
                              </div>
                            )}
                          </div>
                          <div>
                            <Button
                              variant="link"
                              className="text-danger p-0 mt-1 remove-btn"
                              onClick={() => removeItem(item.id)}
                            >
                              <FaTrash /> Remove
                            </Button>
                          </div>
                        </Col>
                        <Col xs={4} sm={4} className="text-end order-product-actions">
                          <div className="quantity-controls">
                            <Button
                              size="sm"
                              variant="outline-secondary"
                              onClick={() => decreaseQty(item.id)}
                            >
                              –
                            </Button>
                            <span className="qty-count mx-2">{item.qty}</span>
                            <Button
                              size="sm"
                              variant="outline-secondary"
                              onClick={() => increaseQty(item.id)}
                            >
                              +
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    ))
                  )}
                </Card>
              </Col>

              {/* Delivery & Price Details */}
              <Col md={4}>
                {/* Delivery Address */}
                <Card className="mb-3 p-3 custom-card">
                  <h6>
                    <b>Delivery Address</b>
                  </h6>
                  <Form onSubmit={handlePlaceOrder}>
                    <Form.Group className="mb-2">
                      <Form.Control
                        placeholder="Name *"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Control
                        type="tel"
                        placeholder="+91 Phone *"
                        value={phone}
                        maxLength={10}
                        onChange={handlePhoneChange}
                        onBlur={() => recordAbandonedCart(phone, name)}
                        required
                      />
                      {phoneError && (
                        <Form.Text className="text-danger">
                          {phoneError}
                        </Form.Text>
                      )}
                    </Form.Group>
                    <Form.Group>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        onBlur={() => recordAbandonedCart(phone, name)}
                        required
                      />
                    </Form.Group>
                  </Form>
                </Card>

                {/* Price Details */}
                <Card className="mb-3 p-3 custom-card">
                  <h6>
                    <b>Price Details</b>
                  </h6>
                  <div className="d-flex justify-content-between mb-2">
                    <span>MRP Total</span>
                    <span>₹ {grossSubTotal.toFixed(2)}</span>
                  </div>
                  {totalDiscountAmount > 0 && (
                    <div className="d-flex justify-content-between mb-2 text-danger">
                      <span>{isPerProductDiscount ? "Product Discount" : "Overall Discount"}</span>
                      <span>- ₹ {totalDiscountAmount.toFixed(2)}</span>
                    </div>
                  )}
                  {isGstEnabled && totalTax > 0 && (
                    <>
                      <div className="d-flex justify-content-between mb-2 text-muted" style={{ fontSize: '13px' }}>
                        <span>Taxable Value</span>
                        <span>₹ {totalTaxable.toFixed(2)}</span>
                      </div>
                      {!isInterState ? (
                        <>
                          <div className="d-flex justify-content-between mb-1 text-muted" style={{ fontSize: '13px' }}>
                            <span>CGST</span>
                            <span>{exclusiveTax > 0 ? `+ ₹ ${cgst.toFixed(2)}` : `₹ ${cgst.toFixed(2)} (incl.)`}</span>
                          </div>
                          <div className="d-flex justify-content-between mb-2 text-muted" style={{ fontSize: '13px' }}>
                            <span>SGST</span>
                            <span>{exclusiveTax > 0 ? `+ ₹ ${sgst.toFixed(2)}` : `₹ ${sgst.toFixed(2)} (incl.)`}</span>
                          </div>
                        </>
                      ) : (
                        <div className="d-flex justify-content-between mb-2 text-muted" style={{ fontSize: '13px' }}>
                          <span>IGST</span>
                          <span>{exclusiveTax > 0 ? `+ ₹ ${igst.toFixed(2)}` : `₹ ${igst.toFixed(2)} (incl.)`}</span>
                        </div>
                      )}
                    </>
                  )}
                  <hr />
                  <div className="d-flex justify-content-between fw-bold">
                    <span>To Pay</span>
                    <span>₹ {total.toFixed(2)}</span>
                  </div>
                  {totalDiscountAmount > 0 && (
                    <div
                      className="mt-3 p-2 rounded-3 text-center fw-bold"
                      style={{
                        backgroundColor: "rgba(25, 135, 84, 0.1)",
                        color: "#198754",
                        fontSize: "13px"
                      }}
                    >
                      🎉 You saved ₹ {totalDiscountAmount.toFixed(2)} on this order!
                    </div>
                  )}
                  {/* <div
                    style={{
                      color: "green",
                      fontSize: "12px",
                      marginTop: "5px",
                    }}
                  >
                    Add items worth ₹ {Math.max(845 - subTotal, 0).toFixed(2)}{" "}
                    more to place an order
                  </div> */}
                </Card>

                {/* Place Order Button (now triggers handlePlaceOrder with validation) */}
                <Button
                  variant="secondary"
                  className="w-100"
                  onClick={handlePlaceOrder}
                  disabled={
                    cart.length === 0 ||
                    !name ||
                    !phone ||
                    !address ||
                    isSubmitting
                  }
                >
                  {isSubmitting ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Placing Order...
                    </>
                  ) : (
                    "Place Order"
                  )}
                </Button>
                {error && (
                  <Alert variant="danger" className="mt-3">
                    {error}
                  </Alert>
                )}
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Popup for Order Confirmation (DYNAMICALLY UPDATED) */}
        <Modal
          show={showPopup}
          onHide={closePopup}
          centered
          backdrop="static"
          keyboard={false}
          contentClassName={storeTheme}
        >
          <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="popup-content">
            <img
              src="https://vyaparwebsiteimages.vypcdn.in/catalogue/done-large.svg?w=64&q=75"
              alt="Tick Icon"
              className="tick-icon"
            />
            <h4 className="order-placed">Order Placed!</h4>
            <p className="order-id">Your Order ID is {orderId}.</p>
            <p className="order-success">
              Your order was placed successfully from <b>{companyName}</b>
            </p>

            {/* 2 ACTIONS: CALL STORE & SEND WHATSAPP (Download PDF hidden for now, can be enabled in next update) */}
            <div className="popup-actions mt-3">
              <Row className="contact-row justify-content-center g-2">
                {/* 1. CALL OPTION */}
                <Col xs={6} className="contact-col px-1">
                  <a href={`tel:${contactNumber}`} className="contact-box call-action-btn">
                    <FaPhoneAlt size={14} className="contact-icon phone-icon" />
                    <span className="contact-text">Call Store</span>
                  </a>
                </Col>

                {/* 2. WHATSAPP OPTION */}
                <Col xs={6} className="contact-col px-1">
                  <a
                    href={waPdfLink || waOrderLink || whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-box whatsapp-action-btn"
                  >
                    <FaWhatsapp size={16} className="contact-icon whatsapp-icon" />
                    <span className="contact-text">Send WhatsApp</span>
                  </a>
                </Col>
              </Row>

              {/* 3. DOWNLOAD PDF RECEIPT OPTION (HIDDEN FOR NOW; UNCOMMENT IN NEXT UPDATE) */}
              {/*
              <div className="pdf-action-wrapper mt-2">
                {pdfUrl ? (
                  <a
                    href={pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-box pdf-action-btn"
                  >
                    <FaFilePdf size={17} className="contact-icon pdf-icon" />
                    <span className="contact-text">Download PDF Receipt</span>
                  </a>
                ) : placedOrderData ? (
                  <PDFDownloadLink
                    document={
                      <Bill
                        data={placedOrderData}
                        companyDetails={companyDetails}
                      />
                    }
                    fileName={`Order_${orderId || "receipt"}.pdf`}
                    className="contact-box pdf-action-btn"
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          <span className="contact-text">Preparing PDF...</span>
                        </>
                      ) : (
                        <>
                          <FaFilePdf size={17} className="contact-icon pdf-icon" />
                          <span className="contact-text">Download PDF Receipt</span>
                        </>
                      )
                    }
                  </PDFDownloadLink>
                ) : (
                  <button
                    type="button"
                    onClick={handlePrintReceiptFallback}
                    className="contact-box pdf-action-btn"
                  >
                    <FaFilePdf size={17} className="contact-icon pdf-icon" />
                    <span className="contact-text">Download / View Receipt</span>
                  </button>
                )}
              </div>
              */}
            </div>

            <hr className="popup-divider" />
            <p className="popup-footer-text">
              <b>{companyName}</b> and 1 Lakh+ users are using our site to get
              orders online.
            </p>
          </Modal.Body>
        </Modal>
      </Container>
    </div>
  );
};

export default OrderPage;
